// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2025 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { fontConfig } from "@awc/XDL/PreStyle/typography";
import { avoidBreakInsidePrintElement, xScreen } from "@awc/XDL/Utilities";
import { AddressInfoDisplayStyles } from "@insite/content-library/Components/AddressInfoDisplay";
import { SmallHeadingAndTextStyles } from "@insite/content-library/Components/SmallHeadingAndText";
import { TypographyProps } from "@insite/mobius/Typography";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import { css } from "styled-components";

interface OrderInformationStyles {
    label?: TypographyProps;
    value?: TypographyProps;
    labelWithDots?: TypographyProps;
    headingAndTextStyles?: SmallHeadingAndTextStyles;
    address?: { heading?: TypographyProps; informationTitle?: TypographyProps } & AddressInfoDisplayStyles;
    note?: { wrapper?: InjectableCss; title?: TypographyProps; text?: TypographyProps };
    orderSummary?: any;
}

const xOrderInformationStyles: OrderInformationStyles = {
    label: {
        variant: "h3",
        transform: "none",
        color: "primary",
        css: css`
            margin-right: 16px;
            margin-bottom: 0;

            @media print {
                display: block;
            }
        `,
    },
    value: {
        variant: "h3",
        weight: fontConfig.weight.regular,
        color: "primary",
        css: css`
            margin-bottom: 0;

            @media print {
                display: inline-block;
                width: auto;
            }
        `,
    },
    address: {
        informationTitle: {
            variant: "h3",
            color: "primary",
        },
        heading: {
            variant: "h3",
            color: "primary",
        },
    },
    note: {
        text: {
            variant: "h6",
            weight: fontConfig.weight.regular,
            css: css`
                margin-bottom: 0;
            `,
        },
    },
    orderSummary: {
        css: css`
            ${avoidBreakInsidePrintElement}
            ${xScreen("lte", "md")} {
                margin-bottom: 10px;
            }
        `,
    },
};

xOrderInformationStyles.labelWithDots = {
    variant: "h3",
    transform: "none",
    color: "primary",
    css: css`
        margin-right: 16px;
        margin-bottom: 0;
        white-space: nowrap;
        &:after {
            content: ":";
        }
        @media print {
            display: inline-block;
            width: auto;
        }
    `,
};

xOrderInformationStyles.headingAndTextStyles = {
    wrapper: {
        css: css`
            display: flex;
            flex-direction: row;
            margin-bottom: 6px;
            @media print {
                display: block;
            }
        `,
    },
    heading: {
        ...xOrderInformationStyles.labelWithDots,
    },
    text: {
        ...xOrderInformationStyles.value,
    },
};

export default xOrderInformationStyles;
